module.exports = __webpack_public_path__ + "static/measure-46a0735715f0987d21425dc1dcd2df7e.mp4";